import { render, staticRenderFns } from "./SuppliesCompanyEducation.vue?vue&type=template&id=817a152e&scoped=true"
import script from "./SuppliesCompanyEducation.vue?vue&type=script&lang=js"
export * from "./SuppliesCompanyEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817a152e",
  null
  
)

export default component.exports